import { useAtomValue, useSetAtom } from 'jotai'
import { captchaStatusAtom, resetCaptchaAtom } from 'components/auth/lib/atoms'
import { c, FC } from 'lib/component-utils'
import { useIntl } from 'lib/intl-utils'

const CaptchaError: FC = ({ className, ...props }) => {
  const { t } = useIntl()
  const { failed } = useAtomValue(captchaStatusAtom)
  const resetCaptcha = useSetAtom(resetCaptchaAtom)

  if (!failed) return null

  return (
    <div className={c`text-sm text-red-600 ${className}`} {...props}>
      {t`captcha.failed`}{' '}
      <button type="button" className="underline" onClick={resetCaptcha}>
        {t`captcha.retry`}
      </button>
    </div>
  )
}

export default CaptchaError
